import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from '../../../core/services/general.service';
import { environment } from '../../../../environments/environment'

const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;

@Component({
    selector: 'app-empresa',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './empresa.component.html',
    styleUrl: './empresa.component.scss'
})
export class EmpresaComponent {
    empresas: any[] = [];

    // Formulario empresa
    formMode: 'create' | 'edit' | null = null;
    currentEmpresa: any = this.emptyForm();

    // Sub-empresa
    showSubForm: boolean = false;
    activeMaestro: string = '';
    newSub = { rfc_secundario: '', alias: '' };

    loading = false;

    constructor(private http: HttpClient, private generalService: GeneralService) {
        this.loadEmpresas();
    }

    emptyForm() {
        return { rfc: '', razon_social: '', domicilio_fiscal: '', cp: '', email_contacto: '', status: 1 };
    }

    get headers() {
        return { headers: new HttpHeaders().set('X-Api-Key', API_KEY) };
    }

    // ─── CRUD Empresa ──────────────────────────────────────────────────────────

    loadEmpresas(): void {
        this.loading = true;
        this.http.post<any>(`${END_POINT}/empresa/getcompanies`, {}, this.headers).subscribe({
            next: res => { this.loading = false; if (!res.error) this.empresas = res.message; },
            error: () => { this.loading = false; }
        });
    }

    openCreate(): void {
        this.currentEmpresa = this.emptyForm();
        this.formMode = 'create';
    }

    openEdit(emp: any): void {
        this.currentEmpresa = { ...emp };
        this.formMode = 'edit';
    }

    cancelForm(): void {
        this.formMode = null;
    }

    saveEmpresa(): void {
        this.http.post<any>(`${END_POINT}/empresa/save`, this.currentEmpresa, this.headers).subscribe(res => {
            if (res.error) {
                this.generalService.showMessage('warn', res.message);
            } else {
                this.generalService.showMessage('success', res.message);
                this.formMode = null;
                this.loadEmpresas();
            }
        });
    }

    deleteEmpresa(emp: any): void {
        if (!confirm(`¿Eliminar la empresa ${emp.razon_social} (${emp.rfc})?`)) return;
        this.http.post<any>(`${END_POINT}/empresa/delete`, { rfc: emp.rfc }, this.headers).subscribe(res => {
            if (res.error) {
                this.generalService.showMessage('warn', res.message);
            } else {
                this.generalService.showMessage('success', res.message);
                this.loadEmpresas();
            }
        });
    }

    // ─── Grupos (sub-empresas) ─────────────────────────────────────────────────

    toggleSubForm(rfc: string): void {
        if (this.activeMaestro === rfc && this.showSubForm) {
            this.showSubForm = false;
            this.activeMaestro = '';
        } else {
            this.activeMaestro = rfc;
            this.newSub = { rfc_secundario: '', alias: '' };
            this.showSubForm = true;
        }
    }

    addSub(): void {
        this.http.post<any>(`${END_POINT}/empresa/addsub`, {
            rfc_maestro: this.activeMaestro,
            ...this.newSub
        }, this.headers).subscribe(res => {
            if (res.error) {
                this.generalService.showMessage('warn', res.message);
            } else {
                this.generalService.showMessage('success', res.message);
                this.showSubForm = false;
                this.loadEmpresas();
            }
        });
    }
}
